import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import type { Resolver } from 'react-hook-form';

const localizationSchema = z.object({
  text: z.string().min(1, "Can't be empty"),
  language: z.string().min(1, "Can't be empty"),
});

const schema = z.object({
  text: z.string().min(1, "Can't be empty"),
  language: z.string().min(1, "Can't be empty"),
  default_flow_id: z.number().optional(),
  localizations: z.array(localizationSchema).refine(
    (localizations) => {
      return localizations.every((loc) => {
        return loc.text && loc.language;
      });
    },
    {
      message: 'Please fill in all required fields in localizations',
      path: ['localizations'],
    }
  ),
});

export default {
  schema,
  resolver: zodResolver(schema),
} as {
  schema: typeof schema;
  resolver: Resolver<z.infer<typeof schema>>;
};
